export default {
  FlowRecord: '流量记录',
  UpFlowRecord: '上行流量记录',
  DownFlowRecord: '下行流量记录',
  UpFlowTitle1: '流量记录功能为您记录网关的传入和传出流量。其中近30天的为详细流量数据，超过30天前的数据请前往流日志进行下载。您可以勾选记录进行禁用管控，快速创建访问控制规则，您可前往',
  AccessControl: '访问控制',
  UpFlowTitle2: '进行查看和管理。', // title1,AccessControl,title2本为一句话，由于访问控制为可点击链接，所以拆开
  AccessDomainIpPort: '访问域名/ip/端口',
  UserIp: '用户ip',
  AppName: '应用名称',
  AccessFlow: '访问流量',
  AccessTime: '访问时间',
  DownFlowTitle: '流量记录列表展示网关的传入和传出流量信息，帮助您监控网络流量。您可以勾选记录进行禁用管控，设置禁用后将同步创建访问控制规则，您可前往', // 拆分理由同上
  BatchControl: '批量管控',
  SearchPH: '搜索源IP/目标域名/目标IP',
  BanDomain: '禁用域名',
  SrcIpPort: '来源ip/端口',
  DestIpPort: '目标ip/端口',
  Protocol: '协议',
  App: '应用',
  SetFlowControl: '设置流量管控',
  InDirection: '入方向',
  OutDirection: '出方向',
  ControlDetail: '管控详情',
  BanAccessDomain: '禁止网关访问以下域名',
  BanAccessQuintuple: '禁止网关访问以下五元组',
  Prompt: '提示',
  ExistedPrompt1: '当前五元组/域名已存在关联规则，无需重复添加，您可前往',
  AccessControlFlow: '访问控制-流量管控规则', // prompt1与AccessControlFlow拆分理由同上
  PartialExistencePrompt: '部分五元组/域名已存在关联规则，无需重复添加。已为您筛选未设置的部分，您可继续设置。',
  ContinueSet: '继续设置',
  SetSuccess: '设置成功',
  CreatedAccessControl: '已创建流量管控规则，您可前往访问控制进行查看和管理。',
  LogDownload: '流日志下载',
  Time: '起始时间/时长(h)',
  LogSize: '日志大小',
  Download: '下载',
  LogDownloadAlert: '流日志下载功能支持下载6个月内的流量记录，帮助您监控网络流量，对用户上网行为进行审计管理和排查网络故障。您只需查询您需要下载的时间区间及关联网关后下载即可。',
  Inquire: '查询',
  BatchDownload: '批量下载',
  SettingFlowTips1: '设置流量管控将为您生成对应的流量管控规则，您可前往',
  SettingFlowTips2: '进行查看和管理。单个网关最多关联100条访问控制规则，超出将被限制关联。',
  LastAssociatedRules: '剩余可关联规则数',
  SelectedAndCurrentRules: '已选/本次流控规则数',
  MaximumAssociationExceededTips: (num: number) => `网关剩余可关联规则数小于本次流控生成规则数，无法全部关联至当前网关。默认选择前${num}条，您可自行调整。`,
  SetFlowControlSearchPlaceholder: '搜索规则名信息（域名或IP）',
  FlowControlRuleTips: (totalLenth: number, maxLength: number) => `提醒：流控规则共${totalLenth}条，最多可选${maxLength}条，全选默认选中前${maxLength}条。如有需要您可自行调整`,
  TrafficThisMonth: '近30天流量',
  Initiator: '发起方',
  Responder: '响应方',
  SelectControlObject: '选择管控对象',
  ConfirmControlRules: '确认管控规则',
  HistoryFlow: '历史流量',
  AccessDate: '访问日期',
  DedicatedTraffic: '专线流量',
  DedicatedTrafficTips: '专线流量记录功能为您记录近30天通过专线访问的流量记录。专线资源请联系运维工程师为您添加配置。',
  DedicatedTrafficSearchPlaceholder: '搜索设备/节点/IP/域名',
  InitiatorDevice: '发起方设备',
  ResponderDevice: '响应方设备',
}